// store/modules/offers.module.js
import offerService from "@/services/offer.service";

export const offers = {
  namespaced: true,
  state: () => ({
    offerList: [],
  }),
  mutations: {
    SET_OFFERS(state, offers) {
      state.offerList = offers;
    },
  },
  actions: {
    async fetchOffers({ commit }) {
      try {
        const response = await offerService.getOffers();
        commit("SET_OFFERS", response.data.list);
        return response.data.list;
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
  getters: {
    offers: (state) => state.offerList,
  },
};
